import { Beneficiario } from "../../interfaces/entities/Beneficiario";

export const setBenef = (benef: Beneficiario): void => {
  var data = JSON.stringify(benef);
  sessionStorage.setItem('beneficiario', data);
}

export const getBenef = (): Beneficiario | null => {
  const benef = sessionStorage.getItem('beneficiario');
  var data: Beneficiario = JSON.parse(benef ? benef : '');
  return data;
}